import { cloneElement, forwardRef, type ReactElement } from "react";
import { mmcArray } from "../../../utils/functions";
import * as styles from "./styles.css";

interface GridProps extends React.HTMLAttributes<HTMLDivElement> {
  elementsPerRow?: number[];
  children: ReactElement[];
  gap?: string;
}

export const Grid = forwardRef(
  (
    { elementsPerRow, gap = "8px", children, ...props }: GridProps,
    ref: React.Ref<HTMLDivElement>,
  ) => {
    const colCount = mmcArray(elementsPerRow || [1]);
    let start = 0;

    return (
      <div
        ref={ref}
        className={styles.gridContainer}
        style={{
          [styles.gapVar]: gap,
          [styles.colCountVar]: colCount,
        }}
        {...props}
      >
        {elementsPerRow?.map((rowCount) => {
          const elementsToReturn = children
            .slice(start, start + rowCount)
            .map((child) => {
              return cloneElement(child, {
                style: {
                  ...child.props.style,
                  gridColumn: `span ${colCount / rowCount}`,
                },
              });
            });
          start += rowCount;
          return elementsToReturn;
        })}
        {children.slice(start).map((child) => {
          return child;
        })}
      </div>
    );
  },
);

Grid.displayName = "Grid";
